import classNames from 'classnames';
import { FC } from 'react';
import Markdown from 'react-markdown';

import { JsonSchema, JsonSchemaOrRef } from '../../api/documentation.api';
import * as Styles from './docs.module.scss';

function getDescription(
    schema: JsonSchemaOrRef,
    resolveSchemaRef: (ref: string) => JsonSchema,
): string | undefined {
    if ('$ref' in schema) {
        return getDescription(resolveSchemaRef(schema.$ref), resolveSchemaRef);
    }
    if (schema.description) {
        return schema.description;
    }
    if ('allOf' in schema) {
        for (const subschema of schema.allOf!.toReversed()) {
            const description = getDescription(subschema, resolveSchemaRef);
            if (description) {
                return description;
            }
        }
    }
}

export const SchemaDescription: FC<{
    schema: JsonSchema;
    resolveSchemaRef: (ref: string) => JsonSchema;
}> = ({ schema, resolveSchemaRef }) => {
    const description = getDescription(schema, resolveSchemaRef);
    return (
        description && (
            <div className={classNames(Styles.description, 'm-b-1')}>
                <Markdown>{description}</Markdown>
            </div>
        )
    );
};
SchemaDescription.displayName = 'SchemaDescription';
